import { attr, belongsTo } from 'spraypaint';
import ApplicationRecord from './ApplicationRecord';

const PromotionalSalesPage = ApplicationRecord.extend({
  static: {
    jsonapiType: 'promotional_sales_pages',
  },
  attrs: {
    package: belongsTo(),
    position: attr(),
    promoItem: attr(),
    schoolHasAssociatedPackage: attr(),
    studentHasPurchasedPackage: attr(),
    digitalOptionId: attr(),
  },
});

export default PromotionalSalesPage;
